import { Dialog } from "terra-one"
import React from "react"
const popUpDialogVariantsOnLayout = (
  ecommerceSettings,
  isServerError,
  setServerError,
  isSubscriptionError,
  projectSightProductRemoved,
  cartUpdatedByAPI,
  multiErrorMessage,
  handleCloseSubscriptionDialog
) => {
  return (
    <>
      <Dialog
        isOpen={isSubscriptionError}
        onPrimaryButtonClick={() => handleCloseSubscriptionDialog()}
        title={ecommerceSettings?.attentionLabel || "Attention"}
        content={
          ecommerceSettings?.subscriptionTypeErrorDuringCartMerge?.childMarkdownRemark
            ?.rawMarkdownBody || "We tried to combine the products in your guest cart with your saved cart, but we encountered an issue while merging them. When choosing a subscription, please select either monthly or yearly as they cannot be combined. Kindly review your cart before proceeding to checkout."
        }
        primaryButtonText={ecommerceSettings?.continueLabel || "Continue"}
        variant={"primary"}
      />    
      <Dialog
        isOpen={
          projectSightProductRemoved?.removed &&
          projectSightProductRemoved?.products?.length
        }
        onPrimaryButtonClick={() => handleCloseSubscriptionDialog()}
        title={
          ecommerceSettings?.cartUpdatedLabelTextForPopUpDialog ||
          "Cart Updated"
        }
        content={`<div>${
          ecommerceSettings?.popUpDialogCartUpdateNotice
        }<br /><br /><b>
        ${
          ecommerceSettings?.itemsRemovedLabel
        }:</b><br /> ${projectSightProductRemoved?.products?.map(prod => {
          return prod
        })}</div>`}
        primaryButtonText={ecommerceSettings?.okLabel || "OK"}
        variant={"primary"}
      />
      <Dialog
        isOpen={cartUpdatedByAPI}
        onPrimaryButtonClick={() => handleCloseSubscriptionDialog()}
        title={ecommerceSettings?.attentionLabel || "Attention"}
        content={ecommerceSettings?.popUpDialogRegionBlockedText || "The software you are trying to purchase is not available in your country or region."}
        primaryButtonText={ecommerceSettings?.okLabel || "OK"}
        variant={"primary"}
      />
      <Dialog
        isOpen={
          multiErrorMessage?.currencyMismatch &&
          multiErrorMessage?.products?.length
        }
        onPrimaryButtonClick={() => handleCloseSubscriptionDialog()}
        title={
          ecommerceSettings?.cartUpdatedLabelTextForPopUpDialog ||
          "Cart Updated"
        }
        content={`<div>${
          ecommerceSettings?.dialogErrorForCurrencyMismatchRegion
            ?.dialogErrorForCurrencyMismatchRegion ||
          "The items in your cart have been updated for two reasons. Firstly, the prices now match the currency linked to your account address. Secondly, some items have been removed because they are not available for purchase in your region. Please review your cart before proceeding."
        }<br /><br /><b>
        ${
          ecommerceSettings?.itemsRemovedLabel
        }:</b><br /> ${multiErrorMessage?.products?.map(prod => {
          return prod
        })}</div>`}
        primaryButtonText={ecommerceSettings?.okLabel || "OK"}
        variant={"primary"}
      />
      <Dialog
        isOpen={
          multiErrorMessage?.thresholdErrorAndRegionError &&
          multiErrorMessage?.products?.length
        }
        onPrimaryButtonClick={() => handleCloseSubscriptionDialog()}
        title={
          ecommerceSettings?.cartUpdatedLabelTextForPopUpDialog ||
          "Cart Updated"
        }
        content={`<div>${
          multiErrorMessage?.errorForThresholdAndRegion
            ?.errorForThresholdAndRegion ||
          "The items in your cart have been updated for two reasons. Firstly, you've added too many of one item to your cart. Secondly, some items have been removed because they are not available for purchase in your region. Please review your cart before proceeding."
        }<br /><br /><b>
        ${
          ecommerceSettings?.itemsRemovedLabel
        }:</b><br /> ${multiErrorMessage?.products?.map(prod => {
          return ` ${prod}`
        })}</div>`}
        primaryButtonText={ecommerceSettings?.okLabel || "OK"}
        variant={"primary"}
      />
      <Dialog
        isOpen={
          multiErrorMessage?.thresholdCurrencyMisMatchAndRegionBlockedErrors &&
          multiErrorMessage?.products?.length
        }
        onPrimaryButtonClick={() => handleCloseSubscriptionDialog()}
        title={
          ecommerceSettings?.cartUpdatedLabelTextForPopUpDialog ||
          "Cart Updated"
        }
        content={`<div>${
          ecommerceSettings?.errorCurrencyMismatchItemThresholdRegion
            ?.errorCurrencyMismatchItemThresholdRegion ||
          "The items in your cart have been updated for three reasons. Firstly, the prices now match the currency linked to your account address. Secondly, you've added too many of one item to your cart. Thirdly, some items have been removed because they are not available for purchase in your region. Please review your cart before proceeding"
        }<br /><br /><b>
        ${
          ecommerceSettings?.itemsRemovedLabel
        }:</b><br /> ${multiErrorMessage?.products?.map(prod => {
          return ` ${prod}`
        })}</div>`}
        primaryButtonText={ecommerceSettings?.okLabel || "OK"}
        variant={"primary"}
      />
      <Dialog
        isOpen={multiErrorMessage?.currencyMismatchErrorOnly}
        onPrimaryButtonClick={() => handleCloseSubscriptionDialog()}
        title={
          ecommerceSettings?.cartUpdatedLabelTextForPopUpDialog ||
          "Cart Updated"
        }
        content={
          ecommerceSettings?.cartHasBeenUpdatedCurrencyMismatchError ||
          "Your currency has been changed to match the currency associated with your account address."
        }
        primaryButtonText={ecommerceSettings?.continueLabel || "Continue"}
        variant={"primary"}
      />

      <Dialog
        isOpen={multiErrorMessage?.currencyMismatchErrorAndThresholdError}
        onPrimaryButtonClick={() => handleCloseSubscriptionDialog()}
        title={
          ecommerceSettings?.cartUpdatedLabelTextForPopUpDialog ||
          "Cart Updated"
        }
        content={
          ecommerceSettings?.errorForCurrencyMismatchAndThresholdExceeded ||
          "Your cart has been updated for two reasons. First, the prices now reflect the currency associated with your account address. Second, you've added too many of one item to your cart. Please review your cart before proceeding."
        }
        primaryButtonText={ecommerceSettings?.continueLabel || "Continue"}
        variant={"primary"}
      />
      <Dialog
        isOpen={multiErrorMessage?.thresholdErrorOnly}
        onPrimaryButtonClick={() => handleCloseSubscriptionDialog()}
        title={
          ecommerceSettings?.cartUpdatedLabelTextForPopUpDialog ||
          "Cart Updated"
        }
        content={
          ecommerceSettings?.errorForThresholdExceededOnly ||
          "While combining the products in your guest cart with your saved cart, at least one item in your cart has exceeded the maximum allowable quantity. Please review and correct your cart before proceeding to checkout."
        }
        primaryButtonText={ecommerceSettings?.continueLabel || "Continue"}
        variant={"primary"}
      />
    </>
  )
}

export default popUpDialogVariantsOnLayout
